export const getSettingsFromStorage = () => {
    const settings = localStorage.getItem('__DEBUG__');

    if (!settings) {
        return {};
    }

    return JSON.parse(localStorage.getItem('__DEBUG__'));
}
